import React from 'react';
import PropTypes from 'prop-types';

import Card from 'chameleon/ui-stack/ui/card';

const UnitInfoSectionContent = ({ textKey, textValue }) => (
  <div
    aria-label={`${textKey}: ${textValue}`}
    className="grid grid-flow-col auto-cols-max gap-x-2 text-14 font-normal leading-normal text-black"
  >
    {textKey}
    <span className="text-black">{textValue}</span>
  </div>
);

UnitInfoSectionContent.displayName = 'UnitInfoSectionContent';
UnitInfoSectionContent.propTypes = {
  textKey: PropTypes.string,
  textValue: PropTypes.string,
};

UnitInfoSectionContent.defaultProps = {
  textKey: '',
  textValue: '',
};

const UnitInfoSection = ({ unitData }) => {
  const { instructionalPeriods, examWeighting } = unitData;
  return (
    <div className="grid gap-y-3 auto-rows-min mr-16 mt-6">
      <span className="text-14 font-medium leading-normal tracking-wide w-96">
        UNIT INFORMATION
      </span>
      {(examWeighting || instructionalPeriods) && (
        <Card classNames="flex flex-col justify-center border-2 border-gray-400 bg-gray-100 h-30 w-96 pl-2">
          {instructionalPeriods && (
            <UnitInfoSectionContent
              textKey="Instructional Periods"
              textValue={instructionalPeriods}
            />
          )}
          {examWeighting && (
            <UnitInfoSectionContent
              textKey="AP Exam Weighting"
              textValue={examWeighting}
            />
          )}
        </Card>
      )}
    </div>
  );
};

UnitInfoSection.displayName = 'UnitInfoSection';
UnitInfoSection.propTypes = {
  unitData: PropTypes.shape({
    instructionalPeriods: PropTypes.string,
    examWeighting: PropTypes.string,
  }).isRequired,
};

export default UnitInfoSection;
